import Vue from 'vue'

export function createElementMask(el) {
  const rect = el.getBoundingClientRect()
  const cssText = `
      position: fixed;
      z-index: 99999999;
      left: ${rect.left}px;
      top: ${rect.top}px;
      width: ${rect.width}px;
      height: ${rect.height}px;
      background-color: rgba(0, 0, 0, 0)
    `
  const div = document.createElement('div')
  div.style.cssText = cssText
  div.onclick = function(e) {
    e.stopPropagation()
  }
  div.onscroll = function(e) {
    e.stopPropagation()
    e.preventDefault()
  }
  document.body.appendChild(div)
  return div
}
let maskDiv = null
Vue.directive('mask', {
  bind: function(el, binding, vNode) {},
  inserted: function(el) {
    maskDiv = createElementMask(el)
  },
  unbind: function() {
    document.body.removeChild(maskDiv)
  }
})
